import styled from '@emotion/styled';
import {
  Avatar,
  Box,
  Collapse,
  Divider,
  Drawer,
  Icon,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
  mainAppBarDimen,
  // mainAppBarDimenResponsive,
  mainDrawerDimen,
  // mainDrawerDimenResponsive,
  mainLogoDimen,
  // mainLogoDimenResponsive,
  toPixel,
} from '../styles/dimensions';
import {
  ACTION_CLOSE_MAIN_DRAWER,
  ACTION_OPEN_MAIN_DRAWER,
  ACTION_RESET,
} from '../constants';
import { useMainFrameDispatch, useMainFrameState } from '../MainFrame';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { mainDrawerJson } from '../data/mainDrawerJson';
import { useLocation, useNavigate } from 'react-router-dom';

import { auth, signOut } from '../../../firebase';
import _, { findIndex, replace } from 'lodash';
import EnlivLogo from '../../../assets/EnlivLogo';
import EnlivLogoSVG from '../../../assets/enliv_logo.svg';
import { useViewportSize } from '../styles/dimensions/viewportCustomHook';
import {
  clearOrganization,
  setTenantOrganization,
} from '../../../redux/features/currentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { checkPermissions } from '../../../permissions/permission-helper';

const openMixin = theme => {
  return {
    width: mainDrawerDimen.open.width,
    '& .MuiDrawer-paper': {
      width: mainDrawerDimen.open.width,
      backgroundColor: theme.palette.drawerColor,
    },
  };
};

const closeMixin = theme => {
  return {
    width: mainDrawerDimen.closed.width,
    '& .MuiDrawer-paper': {
      width: mainDrawerDimen.closed.width,
      backgroundColor: theme.palette.drawerColor,
      overflowX: 'hidden',
    },
  };
};

const NVDrawer = styled(Drawer, {
  shouldForwardProp: props => true,
})(props => {
  console.log(props);
  const { theme, open } = props;

  return {
    // transition: theme.transitions.create(['width', 'margin'], {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
    // position: open ? 'fixed' : '',
    // top: 0,
    // left: 0,
    // zIndex: theme.zIndex.drawer + 5000,
    ...(open && openMixin(theme)),
    ...(!open && closeMixin(theme)),
  };
});

const MDrawer = props => {
  const PERMISSIONS = useSelector(state => state.current?.permissions || {});
  let navigate = useNavigate();
  const reduxDispatch = useDispatch();
  const { mainDrawerOpen } = useMainFrameState();
  const dispatch = useMainFrameDispatch();

  const [mainDrawerJsonState, setMainDrawerJsonState] = useState(
    mainDrawerJson.filter(f => {
      if (['dashboard', 'About', 'Logout', 'username'].includes(f?.name)) {
        return true;
      } else if (_.isUndefined(PERMISSIONS[f?.name])) {
        return false;
      } else {
        return checkPermissions(PERMISSIONS[f?.name]).some(a => a === true);
      }
    })
  );
  const [cState, setCState] = useState({});

  const { width, height } = useViewportSize();

  const handleIsActive = someID => {
    setMainDrawerJsonState(
      mainDrawerJsonState.map((ele, ind) => {
        if (ind === someID) {
          return { ...ele, isActive: true };
        } else {
          return { ...ele, isActive: false };
        }
      })
    );
  };

  const handlePathnameRefresh = pathname => {
    let customPath = pathname.substring(1, pathname.length);

    customPath = customPath.includes('/')
      ? customPath.substr(0, customPath.indexOf('/'))
      : customPath;
    if (customPath === 'location') {
      customPath = 'locations';
    } else if (customPath === 'organization') {
      customPath = 'organizations';
    }
    //  else if (customPath === 'practitioner') {
    //   customPath = 'practitionerRole';
    // }
    else if (customPath === 'user') {
      customPath = 'account';
    } else if (customPath === 'claim') {
      customPath = 'claims';
    }

    setMainDrawerJsonState(
      mainDrawerJsonState.map((ele, ind) => {
        if (ele.link == customPath) {
          return { ...ele, isActive: true };
        } else {
          return { ...ele, isActive: false };
        }
      })
    );
  };

  const location = useLocation();

  useEffect(() => {
    handlePathnameRefresh(location.pathname);
  }, [location]);

  // useEffect(() => {
  //   if (location.pathname.includes('login')) {
  //     signOut(auth)
  //       ?.then(() => {
  //         console.log(`signout successfull`);
  //         const screenMode = localStorage.getItem('screenMode');
  //         const permissionsValue = localStorage.getItem('permissions');
  //         localStorage?.clear();
  //         localStorage.setItem('screenMode', screenMode);
  //         localStorage.setItem('permissions', permissionsValue);
  //         //clearing organization
  //         reduxDispatch(clearOrganization([]));
  //       })
  //       .catch(e => {
  //         console.log(`some issue in firebase signout`, e);
  //       });
  //   }
  // }, [location?.pathname]);

  const handleOnClick = (isSubmenu = false, data) => {
    if (isSubmenu) {
      setCState({
        ...cState,
        [data.name]: !cState[data.name],
      });
    } else {
      if (data.link === 'logout') {
        navigate(`/login`, {
          state: {
            isLogout: true,
          },
          replace: true,
        });
        // signOut(auth)
        //   ?.then(() => {
        //     console.log(`signout successfull`);
        //     const screenMode = localStorage.getItem('screenMode');
        //     localStorage?.clear();
        //     localStorage.setItem('screenMode', screenMode);
        //     //clearing organization
        //     reduxDispatch(clearOrganization([]));
        //   })
        //   .catch(e => {
        //     console.log(`some issue in firebase signout`, e);
        //   });
      } else if (data.link === 'current username') {
        return '';
      } else {
        navigate(`/${data.link}`, {
          state: {
            structure: data?.structure,
          },
        });
      }
      if (!location?.pathname.includes(data.link)) {
        const regex = /\/([a-zA-Z]+)\b/;
        const match = location.pathname.match(regex);

        if (match) {
          const word = match[1];
          const index = mainDrawerJsonState.findIndex(
            item => item.link === word
          );
          handleIsActive(index);
        } else {
          console.log('No match found.');
        }
        console.log(mainDrawerJsonState);
      }
    }
  };

  const mainDrawerStaticContent = (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: mainAppBarDimen.height,
          ...(mainDrawerOpen && {
            justifyContent: 'flex-end',
          }),
        }}
      >
        {mainDrawerOpen ? (
          <IconButton
            onClick={() => dispatch({ type: ACTION_CLOSE_MAIN_DRAWER })}
          >
            <Icon
              sx={{
                color: 'drawerIcon',
              }}
            >
              chevron_left
            </Icon>
          </IconButton>
        ) : (
          <IconButton
            onClick={() => dispatch({ type: ACTION_OPEN_MAIN_DRAWER })}
          >
            <Icon
              sx={{
                color: 'drawerIcon',
              }}
            >
              menu
            </Icon>
          </IconButton>
        )}
      </Box>
      <Divider
        sx={{
          backgroundColor: 'dividerColor',
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          // padding: 1,
        }}
      >
        {/* <img src={EnlivLogoSVG} width={50} height={50} /> */}
        <IconButton
          onClick={() => {
            navigate(`/`, { replace: true });
          }}
        >
          <EnlivLogo
            backgroundColor={'#fff'}
            width={
              mainDrawerOpen
                ? mainLogoDimen.open.width
                : mainLogoDimen.closed.width
            }
            height={
              mainDrawerOpen
                ? mainLogoDimen.open.height
                : mainLogoDimen.closed.height
            }
          />
        </IconButton>

        <Typography
          sx={{
            color: 'drawerIcon',
          }}
          align="center"
        >
          Enliv{mainDrawerOpen || <br />} Health
        </Typography>
      </Box>
      <Divider
        sx={{
          backgroundColor: 'dividerColor',
        }}
      />
    </Box>
  );

  const mainDrawerDynamicContent = (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <List>
          {/* {mainDrawerJson.map((data, index) => { */}
          {mainDrawerJsonState.map((data, index) => {
            return (
              <>
                <ListItemButton
                  onClick={() => {
                    handleIsActive(index);
                    handleOnClick(data.submenu.length > 0, data);
                  }}
                  key={data.name}
                  sx={{
                    justifyContent: mainDrawerOpen ? 'initial' : 'center',
                    background: `${data.isActive && '#84aec6'}`,
                  }}
                  disableTouchRipple
                >
                  <Tooltip
                    disableInteractive
                    title={data.title}
                    placement="right"
                  >
                    <ListItemIcon
                      sx={{
                        mr: mainDrawerOpen ? 3 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <Icon
                        className={
                          data.title == 'Exports' ? 'jobicon icon-jobs' : ''
                        }
                        sx={{
                          color: 'drawerIcon',
                          fontSize: 19,
                          filter:
                            data.title == 'Exports'
                              ? 'brightness(0) invert(4)'
                              : '',
                        }}
                      >
                        {!data.isAvatar && data.title != 'Exports' && data.icon}
                      </Icon>

                      {data?.isAvatar ? (
                        <Avatar sx={{ marginLeft: -3 }}>
                          {auth?.currentUser?.displayName
                            ?.split(' ')[1]
                            ?.substring(0, 1)}
                        </Avatar>
                      ) : (
                        ''
                      )}
                    </ListItemIcon>
                  </Tooltip>
                  {mainDrawerOpen && (
                    <ListItemText
                      primary={data.title}
                      sx={{
                        opacity: mainDrawerOpen ? 1 : 0,
                        color: 'drawerIcon',

                        marginLeft: `${data.isAvatar && '-7px'}`,
                      }}
                    />
                  )}

                  {data.submenu.length > 0 && mainDrawerOpen && (
                    <>
                      {cState[data.name] ? (
                        <ExpandLess
                          sx={{
                            color: 'drawerIcon',
                          }}
                        />
                      ) : (
                        <ExpandMore
                          sx={{
                            color: 'drawerIcon',
                          }}
                        />
                      )}
                    </>
                  )}
                </ListItemButton>

                {data.title === 'InvoiceNew' && (
                  <Divider
                    sx={{
                      backgroundColor: 'dividerColor',
                    }}
                  />
                )}
                <Collapse in={cState[data.name]} timeout="auto" unmountOnExit>
                  <List>
                    {data.submenu.map((subData, index) => (
                      <ListItemButton
                        sx={{
                          ...(mainDrawerOpen && {
                            pl: 4,
                          }),
                          ...(!mainDrawerOpen && {}),
                        }}
                        onClick={() => handleOnClick(false, subData)}
                      >
                        <ListItemIcon>
                          <Icon
                            fontSize="small"
                            sx={{
                              color: 'drawerIcon',
                            }}
                          >
                            {subData.icon}
                          </Icon>
                        </ListItemIcon>
                        {mainDrawerOpen && (
                          <ListItemText
                            sx={{
                              color: 'drawerIcon',
                            }}
                            primary={subData.title}
                          />
                        )}
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </>
            );
          })}
        </List>
      </Box>
    </>
  );

  return (
    <>
      {/* <div
        style={{
          background: '#0c0c0c69',
          display: mainDrawerOpen ? 'block' : 'none',
          position: 'fixed',
          width: '100dvw',
          height: '100dvh',
          zIndex: '4500',
        }}
        onClick={() => dispatch({ type: ACTION_CLOSE_MAIN_DRAWER })}
      ></div> */}
      <NVDrawer
        vh={height}
        vw={width}
        open={mainDrawerOpen}
        variant="permanent"
      >
        <Box>
          {mainDrawerStaticContent}
          {mainDrawerDynamicContent}
        </Box>
      </NVDrawer>
    </>
  );
};

export default MDrawer;
